"use strict";

import { getNamedContext } from "../getNamedContext.js";
export const HeaderHeightContext = getNamedContext('HeaderHeightContext', undefined);
//# sourceMappingURL=HeaderHeightContext.js.map